import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b528a61"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import { toRefs, ref } from 'vue';
import { RouteNames } from '@/router/names';
import { ICartItem } from '@/store/cart/_types';

import { CartProductInfo, CartProductCountInfo, CartProductPrice } from '@/components/cart/product/_index';


export default /*#__PURE__*/_defineComponent({
  __name: 'CartProduct',
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
  item: ICartItem;
};



const { id, thumbnail } = toRefs(props.item.product);
const isHovered = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("li", {
    onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (isHovered.value = true)),
    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (isHovered.value = false)),
    class: _normalizeClass(["product", { active: isHovered.value }])
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _createVNode(_component_RouterLink, {
      to: { name: _unref(RouteNames).product, params: { id: `${_unref(id)}` } }
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          class: "product__image",
          src: _unref(thumbnail),
          alt: "product"
        }, null, 8 /* PROPS */, _hoisted_1)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["to"]),
    _createVNode(_unref(CartProductInfo), { item: __props.item }, null, 8 /* PROPS */, ["item"]),
    _createVNode(_unref(CartProductCountInfo), {
      item: __props.item,
      isHovered: isHovered.value
    }, null, 8 /* PROPS */, ["item", "isHovered"]),
    _createVNode(_unref(CartProductPrice), { item: __props.item }, null, 8 /* PROPS */, ["item"])
  ], 34 /* CLASS, HYDRATE_EVENTS */))
}
}

})